import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useLastNameFilter = () => {
    const { t } = useTranslation();

    return useMemo(() => ({
        name: "lastName",
        label: t("last-name"),
        type: "text",
    }), [t]);
}
